<agr-page-toolbar
  [pageTitle]="'reference-scheme.overview.title' | translate"
  [hasPrimaryAction]="isAdvisor()"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="onButtonCreate()"
  [emptyTitle]="'reference-scheme.overview.empty.title' | translate"
  [emptyDescription]="'reference-scheme.overview.empty.description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
  [isEmpty]="referenceSchemes()?.length === 0"
  data-test="reference-scheme__overview"
>
  <ng-container actions>
    <div class="flex__child--auto spacing--margin-right flex--row text--small">
      <mat-form-field
        class="flex__child--auto spacing--margin-right countrySelector"
        subscriptSizing="dynamic"
      >
        <mat-select
          [hideSingleSelectionIndicator]="true"
          class="text--small"
          data-placeholder="{{ 'reference-scheme.overview.country' | translate }}"
          data-test="reference-scheme-overview-country-selector"
          (selectionChange)="changeCountrySelection($event)"
          [value]="selectedCountry()"
        >
          <mat-option *ngFor="let country of countries" [value]="country.id">
            {{ 'countries.' + country.id | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <div class="wrapper--spacing-horizontal">
    <agr-table [config]="tableConfig()"> </agr-table>
    <ng-template #columnActiveTemplate let-row="row">
      <mat-slide-toggle
        [hideIcon]="true"
        data-test="reference-scheme__overview-toggle-active"
        color="primary"
        [disabled]="!isAdvisor()"
        [checked]="row.isActive"
        (change)="onToggleActive(row)"
      >
      </mat-slide-toggle>
    </ng-template>
    <ng-template #columnNameTemplate let-row="row">
      <button
        mat-button
        class="button--text"
        (click)="onViewReferenceScheme(row)"
        data-test="reference-scheme__view-button"
      >
        {{ row.name }}
      </button>
    </ng-template>
  </div>
</agr-page-toolbar>
